import React from 'react';
import PropTypes from 'prop-types';
import { FONT, COLOURS, SHADOW } from '../../constants/theme';

/**
 * PixelCard — a compact info card with an icon, title, and text lines.
 *
 * Accepts `lines` as an array of strings which are rendered with <br />
 * separators, avoiding the need for escape sequences in JSX props.
 *
 * @param {object}   props
 * @param {string}   props.icon    - Emoji or short text icon.
 * @param {string}   props.title   - Card heading (rendered in primary colour).
 * @param {string[]} props.lines   - Body text lines.
 */
function PixelCard({ icon, title, lines }) {
  return (
    <div
      style={{
        background: COLOURS.cream,
        border:     `2px solid ${COLOURS.borderGold}`,
        padding:    10,
        boxShadow:  SHADOW.card,
        fontFamily: FONT,
      }}
    >
      <div style={{ fontSize: 18, marginBottom: 6 }} aria-hidden="true">
        {icon}
      </div>
      <div style={{ fontSize: 7, color: COLOURS.primary, marginBottom: 4 }}>
        {title}
      </div>
      <div style={{ fontSize: 6, color: COLOURS.textMid, lineHeight: 1.9 }}>
        {lines.map((line, idx) => (
          <React.Fragment key={idx}>
            {line}
            {idx < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

PixelCard.propTypes = {
  icon:  PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  lines: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default PixelCard;
